import './blog-articles.scss';

// Components
import '@/components/avatar/avatar';
import '@/components/comment/comment';

// Sections
import '@/sections/comment-section/comment-section';
